function generateStylesheetFromCssClassesToGenerateList(newClassName, allClassesList) {
  // Create a temporary element to apply and read styles
  const tempElement = document.createElement('div');
  document.body.appendChild(tempElement);

  allClassesList.forEach(className => {
    if (className) {
      tempElement.classList.add(className);
    }
  });

  const styleSheets = document.styleSheets;
  let combinedStyles = {};

  // Iterate over all stylesheets
  for (let sheet of styleSheets) {
    try {
      // Recursively process CSS rules
      combinedStyles = combineStylesRecursive(sheet.cssRules, allClassesList, combinedStyles);
    } catch (e) {
      // Catch and ignore any errors (likely due to cross-origin restrictions)
      if (e instanceof DOMException) {
        // console.warn('Cannot access cssRules for stylesheet:', sheet.href);
      } else {
        throw e; // rethrow if it's a different error
      }
    }
  }

  // Remove the temporary element from the document
  document.body.removeChild(tempElement);

  // Construct and return the CSS rule as a string
  let cssRule = `${newClassName} {\n`;

  for (let property in combinedStyles) {
    const { value, important } = combinedStyles[property];
    cssRule += `  ${property}: ${value}${important ? ' !important' : ''};\n`;
  }

  cssRule += `}`;

  return cssRule;
}

function combineStylesRecursive(rules, allClassesList, combinedStyles) {
  // Recursive function to handle nested CSS rules
  for (let rule of rules) {
    if (rule.cssRules && rule.cssRules.length > 0) {
      // If the rule has nested rules, recursively process them
      if (rule.type === CSSRule.STYLE_RULE) {
        combinedStyles = combineStylesRecursive(rule.cssRules, allClassesList, combinedStyles);
      }
    } else {
      // If it's a style rule and matches any of the classes, combine styles
      if (rule.type === CSSRule.STYLE_RULE && containsClassNameInText(allClassesList, rule.selectorText)) {
        for (let i = 0; i < rule.style.length; i++) {
          const styleName = rule.style[i];
          const styleValue = rule.style.getPropertyValue(styleName);
          const isImportant = rule.style.getPropertyPriority(styleName) === 'important';

          // Add or overwrite the property in the combined styles
          combinedStyles[styleName] = {
            value: styleValue,
            important: isImportant
          };
        }
      }
    }
  }

  return combinedStyles;
}

function containsClassNameInText(classNames, text) {
  const selectorClassNames = text.match(/\.[-\w]+/g) || [];

  return selectorClassNames.some(selectorClassName => classNames.includes(selectorClassName.slice(1)));
}

export default generateStylesheetFromCssClassesToGenerateList;
